export default function initDataTextHelper() {
	// 💡 「js-data-text」というクラスがついた要素をページ内からすべて探す
	const targets = document.querySelectorAll(".js-data-text");

	targets.forEach((target) => {
		// 要素の中のテキスト（空白や改行をトリミングしたもの）を取得
		const text = target.textContent.trim();

		// 自動で data-text="テキスト内容" を付与する
		target.setAttribute("data-text", text);
	});
}
